module.exports = __webpack_public_path__ + "media/images/weather/111_day-404c119addd3c77732973318e0f04df6.png";